import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const DialogStyles: moduleStyleType = {
    bold: {
        fontWeight: '600',
        marginBottom: 2,
    },
}
